export default __webpack_public_path__ + "static/media/NextArrow.461585ce.svg";